// extracted by mini-css-extract-plugin
export default {"header":"HeaderAffida_header__rPg1h","logo":"HeaderAffida_logo__+mv1s","message":"HeaderAffida_message__VWLgY","menuButton":"HeaderAffida_menuButton__D6WEs"};